// recursively build keys by joining each nested key in lowercase with a colon.
type BuildActivityKeys<T, P extends string = ''> = {
  [K in keyof T]: T[K] extends Record<string, unknown>
    ? BuildActivityKeys<T[K], `${P extends '' ? '' : `${P}:`}${Lowercase<K & string>}`>
    : `${P extends '' ? '' : `${P}:`}${Lowercase<K & string>}`
}

export function buildActivityKeys<T extends Record<string, unknown>, P extends string = ''>(
  template: T,
  prefix: P = '' as P,
): BuildActivityKeys<T, P> {
  const result = {} as BuildActivityKeys<T, P>
  // eslint-disable-next-line
  for (const key in template) {
    const lowerKey = key.toLowerCase()
    const newPrefix = prefix ? `${prefix}:${lowerKey}` : lowerKey
    const value = template[key]
    if (typeof value === 'object' && value !== null) {
      result[key as keyof T] = buildActivityKeys(value as Record<string, unknown>, newPrefix) as BuildActivityKeys<
        T,
        P
      >[typeof key]
    } else {
      result[key as keyof T] = newPrefix as BuildActivityKeys<T, P>[typeof key]
    }
  }
  return result
}
